import { render, staticRenderFns } from "./OverviewCRM.vue?vue&type=template&id=b5c1e2f8&scoped=true&"
import script from "./OverviewCRM.vue?vue&type=script&lang=js&"
export * from "./OverviewCRM.vue?vue&type=script&lang=js&"
import style0 from "./OverviewCRM.vue?vue&type=style&index=0&id=b5c1e2f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c1e2f8",
  null
  
)

export default component.exports